import { createFileRoute } from '@tanstack/react-router';

import { SpriteView } from '@/features/sprites/SpriteView';

export const Route = createFileRoute('/_authenticated/sprites/$spriteId')({
  component: SpriteRoute,
});

function SpriteRoute() {
  const { spriteId } = Route.useParams();
  return <SpriteView key={spriteId} spriteId={spriteId} />;
}
